var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 181,
    viewBox: "0 0 167 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.367 17.4707C103.844 46.8933 127.58 70.63 157.003 71.1066C131.76 86.2306 123.072 118.656 137.371 144.375C111.652 130.076 79.2269 138.764 64.1028 164.007C63.6262 134.584 39.8895 110.847 10.4669 110.371C35.7093 95.2467 44.3975 62.8218 30.099 37.1028C55.818 51.4013 88.2429 42.7131 103.367 17.4707Z",
    fill: "#2B2A29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5186 92.6031L67.5538 84.2596C69.0025 82.5234 68.8401 81.221 67.1104 80.4821L66.5795 80.2612L66.8352 79.3069L73.7725 81.1657L73.5266 82.0833C72.1901 82.0793 70.9801 82.7779 69.8329 84.1228L59.0278 96.8458L58.9543 96.8261L56.0003 80.1017C55.6793 78.3633 55.132 77.4692 53.8526 76.8117L54.0985 75.8941L62.4673 78.1365L62.2116 79.0908L61.6413 79.0167C60.1875 78.8632 59.4743 79.6163 59.6806 81.0485L61.2234 90.7069L60.3581 91.7339L60.5186 92.6031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7899 74.6761L78.7413 97.2498C78.338 98.7547 79.0858 99.7812 81.0187 100.496L81.7699 100.776L81.5142 101.73L70.7595 98.8484L71.0153 97.8941L71.769 98.0174C73.8003 98.365 74.9612 97.8499 75.3644 96.3449L80.2229 78.2126C80.5278 77.0747 80.269 76.5726 78.7038 75.3664L77.4028 74.349L84.7899 74.6761Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3738 98.5868L90.4847 99.6883L89.3734 103.836L85.2624 102.734L86.3738 98.5868Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.219 80.6465C112.541 82.0726 115.049 88.5671 112.984 96.2752C110.919 103.983 105.477 108.584 100.521 107.256C95.1991 105.83 92.6905 99.3352 94.7559 91.6271C96.8311 83.8823 102.227 79.3089 107.219 80.6465ZM106.769 82.1783C103.575 81.3226 100.452 85.0493 98.6035 91.9499C96.6069 99.401 97.5208 104.8 100.898 105.704C104.128 106.57 107.297 102.816 109.136 95.9524C111.133 88.5013 110.182 83.0929 106.769 82.1783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersion);
export default __webpack_public_path__ + "static/media/version.d61b9df69bdc81251095292051f50795.svg";
export { ForwardRef as ReactComponent };